/**
 * Bridge attachment ordering for the VM form.
 *
 * Attachment index is NIC index: NIC 0 takes the VM's configured MAC and
 * NIC i a MAC derived from it, so reordering a VM's bridges renumbers its
 * NICs and changes the MAC each guest interface sees.
 */

/**
 * Combine a VM's existing attachment list with the form's selection.
 *
 * Bridges already attached keep their relative order; newly selected ones
 * are appended in the order given. Existing attachments that have no
 * toggle in the form (e.g. a bridge missing from the catalog) cannot have
 * been deselected, so they are kept in place.
 *
 * @param existing  the VM's current bridges, in NIC order
 * @param offered   bridges the form shows a toggle for
 * @param selected  bridges whose toggle is on, in form order
 */
export function orderBridgeSelection(
  existing: readonly string[],
  offered: readonly string[],
  selected: readonly string[],
): string[] {
  const result = existing.filter(b => selected.includes(b) || !offered.includes(b));
  for (const b of selected) {
    if (!result.includes(b)) result.push(b);
  }
  return result;
}
